import React, { useState } from 'react';
import { Button, Result, Space, Statistic, Table, Typography } from 'antd';
import { useUserPotClaims } from './queries';
import { formatDateTime } from '../../utils/format';
import { UserPotClaim } from '../pot/types';
import { isPotAvailable } from '../../config/env';

export function PotHistoryTab({ userID }: { userID: string }) {
  if (!isPotAvailable()) return <Result status="info" title="Coming soon" subTitle="Pot claims and rewards are coming soon to production." />;
  return <PotHistoryContent userID={userID} />;
}

function PotHistoryContent({ userID }: { userID: string }) {
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const history = useUserPotClaims(userID, page, perPage);
  return <>
    <Space className="mb-4 w-full justify-between" wrap>
      <Statistic title="Total Pot claims" value={history.data?.meta.total ?? '-'} />
      <Button loading={history.isFetching} onClick={() => history.refetch()}>Refresh Pot history</Button>
    </Space>
    <Typography.Paragraph type="secondary">Completed claims and their gross reward, rake, and net gold paid. Includes zero-value claims; excludes virtual bot claims.</Typography.Paragraph>
    {history.error ? <Result status="error" title="Failed to load Pot history" subTitle={history.error instanceof Error ? history.error.message : 'Request failed'} extra={<Button onClick={() => history.refetch()}>Retry</Button>} /> :
      <Table<UserPotClaim> rowKey={row => `${row.room_id}:${row.round_id}`} dataSource={history.data?.data || []} loading={history.isLoading} scroll={{ x: 900 }} columns={[
        { title: 'Table ID', dataIndex: 'room_id' },
        { title: 'Room', dataIndex: 'external_room_id' },
        { title: 'Server round ID', dataIndex: 'round_id' },
        { title: 'Cycle', render: (_, row) => row.claim.cycle },
        { title: 'Rounds in cycle', render: (_, row) => row.claim.n },
        { title: 'Gross reward', render: (_, row) => row.claim.gross_amount.toLocaleString() },
        { title: 'Rake', render: (_, row) => row.claim.rake_amount.toLocaleString() },
        { title: 'Net reward', render: (_, row) => row.claim.amount.toLocaleString() },
        { title: 'Round started', dataIndex: 'created_at', render: formatDateTime },
        { title: 'Claimed', dataIndex: 'claimed_at', render: formatDateTime },
      ]} pagination={{ current: page, pageSize: perPage, total: history.data?.meta.total || 0, showSizeChanger: true,
        pageSizeOptions: [20, 50, 100], disabled: history.isPlaceholderData,
        onChange: (nextPage, size) => { setPage(size !== perPage ? 1 : nextPage); setPerPage(size); } }} />}
  </>;
}
